import { DateTime } from 'luxon';
import { createSelector } from 'reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

const selectedLineScheduleEndDateSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => {
    return DateTime.fromISO(facilityViewState.selectedScheduleStartDate)
      .plus({ week: facilityViewState.selectedLineScheduleWeekRange })
      .minus({ day: 1 })
      .toString();
  },
);

export default selectedLineScheduleEndDateSelector;
